import { useState, useEffect, createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import LoadingPage from "../components/LoadingPage";
const loadingContext = createContext();

export default function LoadingProvider({ children }) {
  const location = useLocation();
  const [pathName, setPathName] = useState(location.pathname);
  const [loading, setLoading] = useState({
    isVisible: true,
    animateLoad: "0%", // Start visible
  });

  function DisplayLoading() {
    // let location = useLocation();
    // const currPath = location.pathname;

    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "auto" });
      setPathName(location.pathname);

      setLoading((prev) => ({
        ...prev,
        animateLoad: "0%",
        isVisible: true,
      }));
      function preventScroll(event) {
        event.preventDefault();
      }
      window.addEventListener("scroll", preventScroll, { passive: false });

      const exitTimer = setTimeout(() => {
        setLoading((prev) => ({
          ...prev,
          isVisible: false,
          animateLoad: "-100%",
        }));
        window.removeEventListener("scroll", preventScroll);
      }, 1500);

      return () => {
        clearTimeout(exitTimer);
        window.removeEventListener("scroll", preventScroll);
      };
    }, [location.pathname]);
  }

  return (
    <loadingContext.Provider value={{ loading, DisplayLoading, setPathName }}>
      <LoadingPage
        isVisible={loading.isVisible}
        animateLoad={loading.animateLoad}
      >
        {pathName === "/"
          ? "Home"
          : pathName.charAt(1).toUpperCase() +
            pathName.slice(2, pathName.length)}
      </LoadingPage>
      {children}
    </loadingContext.Provider>
  );
}

export let useLoading = () => useContext(loadingContext);
